import React from "react";
import { Logotypes } from "..";

function Content({ children }) {
  return (
    <div className="content-wrapper">
      <Logotypes />
      <div className="content-container py-3">{children}</div>
    </div>
  );
}

export default Content;
